import { cn } from '@/lib/utils';
import { describeMachineStatus, STATUS_TONE_CLASSES } from '@/lib/machineStatus';
import type { MachineStatus } from '@/types';

/**
 * The one machine-status badge (#804): plain-words label, the raw status
 * code in the tooltip (the install docs' badge table is keyed on it).
 */
export function MachineStatusBadge({ status, className }: { status: MachineStatus | string; className?: string }) {
  const d = describeMachineStatus(status);
  return (
    <span
      className={cn('px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap', STATUS_TONE_CLASSES[d.tone], className)}
      title={`${d.description} (${d.code})`}
      data-testid={`machine-status-${d.code}`}
    >
      {d.label}
    </span>
  );
}

export default MachineStatusBadge;
